import styled from 'styled-components';

export const FormFieldIcon = styled.div`
  svg {
    width: 20px;
    height: 20px;
  }

  button {
    padding: 0;
    color: ${({ theme }) => theme.colors.baseColors.grey100};
    &:hover,
    &:focus-visible {
      color: ${({ theme }) => theme.colors.namedColors.primary};
    }
  }
`;

export const FormFieldContainer = styled.div`
  position: relative;
`;

interface ElementBlockProps {
  $bgColor?: string;
  $borderRadius?: string;
  $textColor?: string;
  $direction?: 'row' | 'column';
  $fontSize?: string;
  $fontWeight?: number;
  $padding?: string;
}

export const ElementBlock = styled.div<ElementBlockProps>`
  display: flex;
  flex-direction: ${({ $direction = 'column' }) => $direction};
  gap: 1.2rem;
  padding: ${({ $padding = '8px 12px 8px 12px' }) => $padding};
  background-color: ${({ $bgColor }) => $bgColor};
  border-radius: ${({ $borderRadius }) => $borderRadius};
  color: ${({ $textColor }) => $textColor};
  font-size: ${({ $fontSize }) => $fontSize};
  font-weight: ${({ $fontWeight }) => $fontWeight};
`;
